import { ORDER_ITEMS } from 'Component/MyAccountOrder/MyAccountOrder.config';
import {
    MyAccountOrderItemsTable as SourceMyAccountOrderItemsTable
} from 'SourceComponent/MyAccountOrderItemsTable/MyAccountOrderItemsTable.component';

import './MyAccountOrderItemsTable.override.style';

/** @namespace PeggysagePwa/Component/MyAccountOrderItemsTable/Component */
export class MyAccountOrderItemsTableComponent extends SourceMyAccountOrderItemsTable {
    /**
     * Override
     * @returns {JSX.Element}
     */
    renderOrderTitleAndActions() {
        const { activeTab, items: { number, items: products = [] } } = this.props;

        if (activeTab === ORDER_ITEMS) {
            const title = products.length > 1 ? __('%s items', products.length) : __('1 item');

            return (
                <div block="MyAccountOrderItemsTable" elem="OrderTitle">
                    { title }
                </div>
            );
        }

        return (
            <div block="MyAccountOrderItemsTable" elem="OrderActions">
                <div block="MyAccountOrderItemsTable" elem="OrderTitle">
                    { `${activeTab} # ${number}` }
                </div>
                { this.renderPrintAction() }
            </div>
        );
    }

    /**
     * Override
     * @returns {JSX.Element}
     */
    render() {
        const { activeTab } = this.props;

        return (
            <div block="MyAccountOrderItemsTable" elem="ProductsWrapper">
                { activeTab === ORDER_ITEMS && (
                    <div block="MyAccountOrderItemsTable" elem="Title">
                        { __('Order Information') }
                    </div>
                ) }
                { this.renderOrderTitleAndActions() }
                <div
                  block="MyAccountOrderItemsTable"
                  elem="Products"
                >
                    { this.renderItems() }
                </div>
                <table
                  block="MyAccountOrderItemsTable"
                  elem="Totals"
                >
                    { this.renderTotals() }
                </table>
                { this.renderComments() }
            </div>
        );
    }
}

export default MyAccountOrderItemsTableComponent;
